import React, { useState, useEffect } from 'react';

const AdvancedFilterModal = ({ isOpen, onClose, currentFilters, onApply, onReset, folders }) => {
  const [tempFilters, setTempFilters] = useState({ ...currentFilters });

  useEffect(() => {
    if (isOpen) {
      console.log("[Modal] Opened. Syncing state:", currentFilters);
      setTempFilters({ ...currentFilters });
    }
  }, [isOpen, currentFilters]);

  if (!isOpen) return null;

  const handleChange = (field, value) => {
    setTempFilters(prev => ({ ...prev, [field]: value }));
  };

  const handleApply = () => {
    onApply(tempFilters);
  };

  return (
    <div className="ad-modal-overlay" onClick={onClose}>
      <div className="ad-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="ad-modal-header">
          <h2>Advanced Filters</h2>
          <button className="ad-close-x" onClick={onClose}>&times;</button>
        </div>
        
        <div className="ad-modal-body">
          <div className="ad-filter-row">
            <div className="ad-filter-group">
              <label>Date Range</label>
              <select 
                value={tempFilters.dateRange} 
                onChange={(e) => handleChange('dateRange', e.target.value)}
              >
                <option value="any">Any Date</option>
                <option value="today">Today</option>
                <option value="week">This Week</option>
              </select>
            </div>
            <div className="ad-filter-group">
              <label>Lot Size (acres)</label>
              <select 
                value={tempFilters.lotSize} 
                onChange={(e) => handleChange('lotSize', e.target.value)}
              >
                <option value="any">Any Size</option>
                <option value="small">Small (&lt; 0.5 acre)</option>
                <option value="medium">Medium (0.5 - 2 acres)</option>
                <option value="large">Large (&gt; 2 acres)</option>
              </select>
            </div>
          </div>

          <div className="ad-filter-row">
            <div className="ad-filter-group">
              <label>Sort By</label>
              <select 
                value={tempFilters.sortBy} 
                onChange={(e) => handleChange('sortBy', e.target.value)}
              >
                <option value="newest">Created Date (Newest First)</option>
                <option value="oldest">Created Date (Oldest First)</option>
              </select>
            </div>
            <div className="ad-filter-group">
  <label>Folder</label>
  <select 
    value={tempFilters.folder} 
    onChange={(e) => handleChange('folder', e.target.value)}
  >
    <option value="any">Any Folder</option>
    {folders && folders.map(f => (
      <option key={f.id} value={f.id}>{f.name}</option>
    ))}
  </select>
</div>
          </div>
        </div>

        <div className="ad-modal-footer">
          <button 
            className="ad-btn-reset" 
            onClick={() => {
              const reset = { dateRange: 'any', lotSize: 'any', sortBy: 'newest', folder: 'any' };
              setTempFilters(reset);
              onReset(reset);
            }}
          >
            Reset All Filters
          </button>
          <div className="ad-footer-right">
            <button className="ad-btn-cancel" onClick={onClose}>Cancel</button>
            <button className="ad-btn-apply" onClick={handleApply}>Apply Filters</button>
          </div>
        </div>
      </div>

      <style>
        {`
        .ad-modal-overlay {
            position: fixed;
            top: 0;
            left: 0;
            width: 100vw;
            height: 100vh;
            background: rgba(0, 0, 0, 0.6);
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 9999; /* Higher than SideMenu and Topbar */
        }
        .ad-modal-content {
            background: #fff;
            width: 100%;
            max-width: 520px;
            border-radius: 12px;
            padding: 24px;
            box-shadow: 0 20px 40px rgba(0,0,0,0.2);
            animation: adFadeIn 0.3s ease;
        }
        @keyframes adFadeIn {
            from { opacity: 0; transform: translateY(-20px); }
            to { opacity: 1; transform: translateY(0); }
        }
        .ad-modal-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 24px;
            border-bottom: 1px solid #eee;
            padding-bottom: 15px;
        }
        .ad-modal-header h2 { font-size: 20px; font-weight: 700; margin: 0; color: #1a202c; }
        .ad-close-x { background: none; border: none; font-size: 28px; cursor: pointer; color: #a0aec0; }
        .ad-filter-row { display: flex; gap: 20px; margin-bottom: 20px; }
        .ad-filter-group { flex: 1; display: flex; flex-direction: column; gap: 8px; }
        .ad-filter-group label { font-size: 14px; font-weight: 600; color: #4a5568; }
        .ad-filter-group select { 
            padding: 12px; 
            border: 1px solid #e2e8f0; 
            border-radius: 8px; 
            font-size: 14px; 
            background-color: #f8fafc;
            color: #2d3748;
        }
        .ad-modal-footer { 
            display: flex; 
            justify-content: space-between; 
            align-items: center; 
            margin-top: 30px;
            padding-top: 20px;
            border-top: 1px solid #eee;
        }
        .ad-btn-reset { background: none; border: none; color: #6f11f5; font-weight: 600; cursor: pointer; text-decoration: underline; }
        .ad-footer-right { display: flex; gap: 12px; }
        .ad-btn-cancel { background: #edf2f7; border: none; padding: 10px 20px; border-radius: 8px; cursor: pointer; font-weight: 600; color: #4a5568; }
        .ad-btn-apply { background: #6f11f5; color: #fff; border: none; padding: 10px 25px; border-radius: 8px; cursor: pointer; font-weight: 600; transition: background 0.2s; }
        .ad-btn-apply:hover { background: #5a0dc7; }
        `}
      </style>
    </div>
  );
};

export default AdvancedFilterModal;